import { JaarPeriode } from '@/enums/Timespan'
import { IExternalProviderUrl, IExternalProviderUrlResponse, IExternalProvidersCollection } from '@/interfaces/IExternalProvider'
import axios from 'axios'

export default class ExternalProviderUrlService {
    // Mock data for development/testing
    private getMockUrls(period: JaarPeriode): IExternalProvidersCollection {
        return {
            volgtoets: [
                {
                    organisatieId: 1,
                    organisatieNaam: 'Volgtoets',
                    url: 'https://dashboard.volgtoets.nl/resultaten',
                    urlNaam: 'Volgtoets Dashboard',
                    urlOmschrijving: 'Bekijk gedetailleerde volgtoets resultaten en analyses',
                    iconUrl: 'https://volgtoets.nl/favicon.ico',
                    urlType: 'dashboard',
                },
                {
                    organisatieId: 2,
                    organisatieNaam: 'Volgtoets',
                    url: 'https://rapport.volgtoets.nl/periode/' + period,
                    urlNaam: 'Volgtoets Rapporten',
                    urlOmschrijving: 'Download rapporten voor de geselecteerde periode',
                    iconUrl: 'https://volgtoets.nl/favicon.ico',
                    urlType: 'rapport',
                },
            ],
            looqinCompetenties: [
                {
                    organisatieId: 3,
                    organisatieNaam: 'LooQin',
                    url: 'https://competenties.looqin.nl/dashboard',
                    urlNaam: 'LooQin Competenties Dashboard',
                    urlOmschrijving: 'Overzicht van competentieontwikkeling per leerling',
                    iconUrl: 'https://looqin.nl/favicon.ico',
                    urlType: 'dashboard',
                },
                {
                    organisatieId: 4,
                    organisatieNaam: 'LooQin',
                    url: 'https://analyse.looqin.nl/competenties/' + period,
                    urlNaam: 'LooQin Competentie Analyse',
                    urlOmschrijving: 'Diepgaande analyse van competentieresultaten',
                    iconUrl: 'https://looqin.nl/favicon.ico',
                    urlType: 'analyse',
                },
            ],
            looqinSociaalEmotioneel: [
                {
                    organisatieId: 5,
                    organisatieNaam: 'LooQin',
                    url: 'https://sociaal.looqin.nl/dashboard',
                    urlNaam: 'LooQin Sociaal-Emotioneel Dashboard',
                    urlOmschrijving: 'Monitor sociaal-emotionele ontwikkeling van leerlingen',
                    iconUrl: 'https://looqin.nl/favicon.ico',
                    urlType: 'dashboard',
                },
                {
                    organisatieId: 6,
                    organisatieNaam: 'LooQin',
                    url: 'https://trends.looqin.nl/sociaal-emotioneel/' + period,
                    urlNaam: 'LooQin SE Trends',
                    urlOmschrijving: 'Trends en patronen in sociaal-emotionele resultaten',
                    iconUrl: 'https://looqin.nl/favicon.ico',
                    urlType: 'trends',
                },
                {
                    organisatieId: 7,
                    organisatieNaam: 'LooQin',
                    url: 'https://interventies.looqin.nl/aanbevelingen',
                    urlNaam: 'LooQin SE Interventies',
                    urlOmschrijving: 'Aanbevelingen voor interventies gebaseerd op resultaten',
                    iconUrl: 'https://looqin.nl/favicon.ico',
                    urlType: 'interventie',
                },
            ],
        }
    }
    getVolgtoetsUrls(period: JaarPeriode) {
        return axios.get<IExternalProviderUrlResponse>(`/api/Frontend/Resultaten/Volgtoets/Overzicht/periode/${period}/urls`)
    }

    getLooqinCompetentieUrls(period: JaarPeriode) {
        return axios.get<IExternalProviderUrlResponse>(`/api/Frontend/Resultaten/Looqin/Overzicht/Competenties/periode/${period}/urls`)
    }

    getLooqinSociaalEmotioneelUrls(period: JaarPeriode) {
        return axios.get<IExternalProviderUrlResponse>(`/api/Frontend/Resultaten/Looqin/Overzicht/SociaalEmotioneel/periode/${period}/urls`)
    }

    async getAllUrls(period: JaarPeriode): Promise<IExternalProvidersCollection> {
        const [volgtoetsResponse, competentiesResponse, sociaalEmotioneelResponse] = await Promise.all([this.getVolgtoetsUrls(period), this.getLooqinCompetentieUrls(period), this.getLooqinSociaalEmotioneelUrls(period)])

        return this.getMockUrls(period)

        return {
            volgtoets: volgtoetsResponse.data.organisatieUrls || [],
            looqinCompetenties: competentiesResponse.data.organisatieUrls || [],
            looqinSociaalEmotioneel: sociaalEmotioneelResponse.data.organisatieUrls || [],
        }
    }

    getCombinedUrls(period: JaarPeriode): Promise<IExternalProviderUrl[]> {
        return this.getAllUrls(period).then((collection) => [...collection.volgtoets, ...collection.looqinCompetenties, ...collection.looqinSociaalEmotioneel])
    }
}

export const externalProviderUrlService: ExternalProviderUrlService = new ExternalProviderUrlService()
